import { useContext } from 'react'

import DataProcessContext from 'contexts/DataProcessContext'

const useDataProcess = () => {
  const context = useContext(DataProcessContext)

  if (context === undefined) {
    throw new Error(
      'useDataProcess must be used within a DataProcessContext.Provider',
    )
  }

  const toStep = (step, activeStep) => {
    if (step < activeStep) {
      context.setActiveStep(step)
    }
  }

  const nextStep = () => {
    context.setActiveStep((prevActiveStep) => prevActiveStep + 1)
    if (context.lastActiveStep === context.activeStep) {
      context.setLastActiveStep((prevActiveStep) => prevActiveStep + 1)
    }
  }

  const backStep = () => {
    context.setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  return {
    activeStep: context.activeStep,
    code: context.code,
    counter: context.counter,
    data: context.data,
    dataCollectedOptions: context.dataCollectedOptions,
    dataProcessSources: context.dataProcessSources,
    dataProcessTemplate: context.dataProcessTemplate,
    departments: context.departments,
    discardModes: context.discardModes,
    internalAllocationModes: context.internalAllocationModes,
    lastActiveStep: context.lastActiveStep,
    laws: context.laws,
    legalFrameworks: context.legalFrameworks,
    loadingReplyLiaAnswer: context.loadingReplyLiaAnswer,
    loadOptions: context.loadOptions,
    protections: context.protections,
    recoveries: context.recoveries,
    reloadOptions: context.reloadOptions,
    setActiveStep: context.setActiveStep,
    setCode: context.setCode,
    setData: context.setData,
    setLastActiveStep: context.setLastActiveStep,
    setLoadingReplyLiaAnswer: context.setLoadingReplyLiaAnswer,
    setSourceOptions: context.setSourceOptions,
    setToNextStep: context.setToNextStep,
    shareProcesses: context.shareProcesses,
    sourceOptions: context.sourceOptions,
    storageLocations: context.storageLocations,
    storageTimes: context.storageTimes,
    titularCategories: context.titularCategories,
    toNextStep: context.toNextStep,
    toStep,
    nextStep,
    backStep,
  }
}

export default useDataProcess
